<template>
    <div class="table-responsive">
        <table :class="'table table-striped table-bordered ' + (hover?'table-hover':'')">
            <thead>
            <tr class="bg-dark text-white">
                <th v-for="header in headers" :key="header.id" class="header-clickable" @click="sortable(header)"
                    style="cursor: pointer">
                    <!--style="cursor:pointer" :class="withStartSticky && header === headers[0]">-->
                    {{header}} 
                    <i v-if="header != 'Perfil' && header != 'Estado'  
                    && header != 'Despacho Progresivo' 
                    && header != 'Empresa/Cliente'
                    && header != 'Progreso Despacho'
                    && header != 'Centros de Costo'
                    && header != 'Unidad de Negocio Asociada'
                    && header != 'Progreso total'" :class="'fa fa-'+getSortingIcon(header)"></i>
                </th>
                <!--<th v-if="hasOptions" :class="withEndSticky ? 'sticky-right':''" style="width: 12%; background: #343A40; border-left: 1px solid #DEE2E6 !important;">Opciones</th>-->
                <th v-if="hasOptions" style="width: 12%;">Opciones</th>
            </tr>
            </thead>
            <tbody>
            <slot></slot>
            </tbody>
        </table>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                name: '',
                isAsc: true,
                urlQuery: {
                    orderBy: ''
                }
            }
        },
        props: ['headers', 'hasOptions','hover','withEndSticky','withStartSticky'],
        methods: {
            sortable(header) {
                if (header != 'Perfil' && header != 'Estado' 
                    && header != 'Despacho Progresivo' 
                    && header != 'Progreso total'
                    && header != 'Centros de Costo'
                    && header != 'Progreso Despacho'
                    && header != 'Unidad de Negocio Asociada'){
                    if (!this.name) {
                        this.name = header;
                        this.urlQuery.orderBy = this.name.replace(/\s/g, '') + '_asc';
                    } else {
                        let position = '';
                        if (this.name === header) {
                            this.isAsc = !this.isAsc;
                        } else {
                            this.name = header;
                            this.isAsc = true;
                        }
                        position = this.isAsc ? 'asc' : 'desc';
                        
                        this.urlQuery.orderBy = this.name.replace(/\s/g, '') + '_' + position
                    }
                    this.getQueryParams(this.urlQuery)
                    this.$router.push({
                        path: this.$route.path,
                        query: this.urlQuery
                    })

                }
                
            },
            getSortingIcon(header) {
                if (header === this.name) {
                    if (this.isAsc) {
                        return 'sort-down'
                    } else {
                        return 'sort-up'
                    }
                } else {
                    return 'sort'
                }
            },
            getQueryParams(obj) {
                for (let prop in this.$route.query) {
                    if (prop !== 'orderBy')
                        obj[prop] = this.$route.query[prop]
                }
            }
        }
    }
</script>
